export class TallyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TallyError';
  }
}